import decode from 'jwt-decode';

export const authService = {
  isTokenExpired: token => {
    try {
      if (!token) return true;
      const now = Date.now().valueOf() / 1000;
      const decoded = decode(token);
      // checking if token is expired
      return typeof decoded.exp !== 'undefined' && decoded.exp < now;
    } catch (e) {
      throw e;
    }
  },
  isTokenRoleForRider: token => {
    try {
      if (!token) return false;
      const decoded = decode(token);
      const { metadata: { roles, roles: [role] = [] } = {} } = decoded;
      return typeof roles !== 'undefined' && role === 'rider';
    } catch (e) {
      throw e;
    }
  },
  getUserIdFromToken: token => {
    try {
      const decoded = decode(token);
      const { sub } = decoded;
      return sub;
    } catch (e) {
      throw e;
    }
  },
  getRideIdFromToken: token => {
    try {
      if (!token) return false;
      const now = Date.now().valueOf() / 1000;
      const decoded = decode(token);
      const { metadata: { ride_id = null } = {} } = decoded;
      // checking if token is not expired
      return typeof decoded.exp !== 'undefined' && decoded.exp > now && ride_id;
    } catch (e) {
      return false;
    }
  },
  getTokenAndIdForDevelopment: () => {
    const substring = window.location.search.substring(1);
    const params = substring.split('&');
    const paramsUrl = {};
    params.forEach(function (option) {
      const item = option.split('=');
      paramsUrl[item[0]] = decodeURIComponent(item[1]);
    });
    return paramsUrl;
  },
  getTokenFromUrl: () => {
    // Retrieves the user token from url
    return new URLSearchParams(window.location.search).get('b');
  },
  getRideIdFromUrl: () => {
    return new URLSearchParams(window.location.search).get('rideId');
  },
  getDelegationToken: () => {
    return localStorage.getItem('delegation_token');
  },
  setDelegationToken: delegationToken => {
    localStorage.setItem('delegation_token', delegationToken);
  },
  getVerificationToken: () => {
    // Retrieves the code verification token localStorage
    return localStorage.getItem('verification_token');
  },
  setVerificationToken: t => {
    localStorage.setItem('verification_token', t);
  },
  logOut: () => {
    localStorage.clear();
    sessionStorage.clear();
  },
};

export default authService;
